// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2481":"2270a58dcb2d95c2","6471":"5098f0abd2f4fc5d","9764":"08c6ace477e36c17"}[chunkId] + ".js";
};